module.exports = __webpack_public_path__ + "media/images/help/delivery/icon-point-1-43f04cd1673b9aca1679735419b1eadd.svg";